<!--suppress HtmlUnknownBooleanAttribute, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a href="javascript:void(0);">
        <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      </a>
    </li>
    <li class="breadcrumb-item">
      <a href="javascript:void(0);" translate>Categories</a>
    </li>
    <li class="breadcrumb-item active" aria-current="page" translate>Categories List</li>
  </ol>
</nav>
<div [hidden]="loading" class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
  <div class="widget-content widget-content-area br-6">
    <div class="table-responsive mb-4 mt-4">
      <table id="multi-column-ordering" class="table table-hover" style="width:100%">
        <thead>
        <tr>
          <th translate>ID</th>
          <th class="d-none" translate>Thumbnail</th>
          <th translate>Title</th>
          <th translate>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let collection of collections">
          <!--          ID -->
          <td>
            <span>{{collection.id}}</span>
          </td>
          <!-- Thumbnail -->
          <td class="d-none">
            <div class="d-flex">
              <div class="usr-img-frame">
                <img alt="collection image" class="img-fluid m-0 p-0" *ngIf="collection.iconImageBytes != null" [src]="'data:image/jpeg;base64,' + collection.iconImageBytes">
                <img alt="Collection" class="img-fluid m-0 p-0" *ngIf="collection.iconImageBytes == null" src="/assets/img/no-image.png">
              </div>
            </div>
          </td>
          <!--Title -->
          <td>
            <p class="align-self-center mb-0 admin-name">{{lang == 'ar' && collection.name_locale && collection.name_locale[lang]? collection.name_locale[lang] : collection.name}}</p>
          </td>

          <!--     Action     -->
          <td class="text-center">
            <div class="dropdown">
              <a class="dropdown-toggle2" href="#" role="button" [id]="'dropdownMenuLink_' + collection.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="19" cy="12" r="1"></circle>
                  <circle cx="5" cy="12" r="1"></circle>
                </svg>
              </a>
              <div class="dropdown-menu" [attr.aria-labelledby]="'dropdownMenuLink_' + collection.id" style="will-change: transform;">
                <a class="dropdown-item" [routerLink]="['/private', 'collections', 'edit', collection.id]" [queryParams]="{type: subAccountType, govId: subAccountGovId}" href="javascript:void(0);" translate>Edit</a>
                <a [hidden]="!isSales && !isMerchant && !isManager" class="dropdown-item" href="javascript:void(0);" data-toggle="modal" [attr.data-target]="'#deleteModal' + collection.id" translate>Delete</a>
              </div>
            </div>
          </td>

          <!-- Modal -->
          <div class="modal fade" [id]="'deleteModal' + collection.id" tabindex="-1" role="dialog" [attr.aria-labelledby]="'deleteModalLabel' + collection.id" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" [id]="'deleteModalLabel' + collection.id">{{'Delete Collection' | translate}}</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
                </div>
                <div class="modal-body">
                  <p class="modal-text">{{'Do you want to delete collection of title' | translate}} "{{lang == 'ar' && collection.name_locale && collection.name_locale[lang] ? collection.name_locale[lang] : collection.name}}"</p>
                </div>
                <div class="modal-footer">
                  <button class="btn" data-dismiss="modal" translate><i class="flaticon-cancel-12"></i>No</button>
                  <button type="button" data-dismiss="modal" class="btn btn-primary" (click)="deleteCollection(collection.id, lang == 'ar' ? collection.name_locale[lang] : collection.name)" translate>Yes</button>
                </div>
              </div>
            </div>
          </div>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th translate>ID</th>
          <th class="d-none" translate>Thumbnail</th>
          <th translate>Title</th>
          <th translate>Actions</th>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
